export default __webpack_public_path__ + "static/illustration-8-770b8613c9ce25b171be3dbc7e8af262.png";